import Vue from 'vue'
import Vuex from 'vuex'
import pathify from 'vuex-pathify'
import { make } from 'vuex-pathify'
import moment from 'moment'

import establishment from './store/modules/establishment'
import experience from './store/modules/experience'
import packageModule from './store/modules/package'
import treatmentModule from './store/modules/treatment'
import serieModule from './store/modules/serie'

Vue.use(Vuex)

const state = {
    calendar: {
        data: {
            staffs: [],
            spaces: [],
            events: [],
            hideEvents: [],
            hideStaffs: [],
            counter: {},
            presets: [],
        },
        params: {
            dateFocus: moment().format('YYYY-MM-DD'),
            viewMode: 'grid',
            showModal: false,
            showModalOrderList: false,
            miniToolBar: false,
            smartResa: false,
            query: {},
            openTimeslot: null,
            lastTime: '18:00',
            firstTime: '07:00',
            nbOfDay: 1,
            intervalXLevel: 0,
            intervalYLevel: 4,
            intervalMinutes: 30,
            modalMobile: false,
            newLogin: false,
        },
        selected: {
            staffs: [],
            spaces: [],
            load: 0,
            search: '',
            preset: null,
            editEvents: [],
            category: null,
            event: null,
            mouseTime: null,
        },
        move: {
            move_id: null,
            move_start: null,
            move_end: null,
            move_event: [],
            move_drag: false,
            move_duration: [],
            move_date: null,
        },
        merge: {
            status: false,
            events: [],
        },
    },
    overlay: {},
}

const mutations = make.mutations(state)

const actions = {
    // Action pour appliquer un preset
    async applyPreset({ state, commit }, { preset, updateSelections = true }) {
        if (!preset) return

        if (updateSelections) {
            // Convertir les IDs en objets complets pour les staffs
            const selectedStaffs = state.calendar.data.staffs.filter((staff) => preset.config.staffs.includes(staff.id))

            // Convertir les IDs en objets complets pour les espaces
            const selectedSpaces = state.calendar.data.spaces.filter((space) => preset.config.spaces.includes(space.id))

            commit('SET_CALENDAR', {
                ...state.calendar,
                selected: {
                    ...state.calendar.selected,
                    staffs: selectedStaffs,
                    spaces: selectedSpaces,
                },
                params: {
                    ...state.calendar.params,
                    nbOfDay: preset.config.nbOfDay,
                    intervalXLevel: preset.config.slideValueX,
                    intervalYLevel: preset.config.slideValueY,
                    intervalMinutes: parseInt(preset.config.timeIntervalMinutes),
                    newLogin: preset.config.newLogin,
                },
            })
        }
    },

    // Action pour effacer un preset
    clearPreset({ state, commit }) {
        commit('SET_CALENDAR', {
            ...state.calendar,
            selected: {
                ...state.calendar.selected,
                staffs: [],
                spaces: [],
                preset: null,
            },
            params: {
                ...state.calendar.params,
                nbOfDay: 1,
                intervalXLevel: 0,
                intervalYLevel: 4,
                intervalMinutes: 30,
                newLogin: false,
            },
        })
    },
}

export default new Vuex.Store({
    plugins: [pathify.plugin],
    state,
    mutations,
    actions,
    modules: {
        establishment,
        experience,
        package: packageModule,
        treatment: treatmentModule,
        serie: serieModule,
    },
})
